import { useTable } from 'react-table';
import './Table.css';
const Table = ({ columns, data, haveCheckBox = false }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data })
    return (
        <>
            <div className='table-responsive mt-2'>
                <table {...getTableProps()} class="table card-table border table-vcenter text-nowrap align-items-center">
                    <thead class="thead-light">
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                               
                                {headerGroup
                                    .headers
                                    .map(column => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}
                               
                            </tr>
                        ))}

                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row);
                           
                            return (
                                <tr {...row.getRowProps()}>
                                    { console.log("s",row?.getRowProps())}
                                    {row
                                        .cells
                                        .map(cell => {
                                            if(row?.Header==" "){
                                                return <td {...cell.getCellProps()}><input/></td>
                                            }else{
                                            return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>}
                                        })}

                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>
        </>



    );
}

export default Table;